import { useEffect } from "react";
import api from "@/lib/api";

let injected = false;

export function useGA4() {
  useEffect(() => {
    if (injected) return;
    api
      .get("/settings")
      .then((r) => {
        const id = r.data.ga4_measurement_id;
        if (!id || injected) return;
        if (!/^G-[A-Za-z0-9]{4,20}$/.test(id.trim())) return;
        injected = true;
        const s1 = document.createElement("script");
        s1.async = true;
        s1.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        document.head.appendChild(s1);
        const s2 = document.createElement("script");
        s2.textContent = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${id}');`;
        document.head.appendChild(s2);
      })
      .catch(() => {});
  }, []);
}
